import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap" }
const _hoisted_2 = { class: "col-12 xl:col-12" }
const _hoisted_3 = { class: "card property-services-section" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "col-fixed align-self-end align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-comments",
  style: {"font-size":"1.5rem"}
}
const _hoisted_7 = {
  key: 1,
  class: "pi pi-comments",
  style: {"font-size":"1.5rem","color":"gray"}
}
const _hoisted_8 = {
  key: 0,
  class: "pi pi-lock-open",
  style: {"font-size":"1.5rem"}
}
const _hoisted_9 = {
  key: 1,
  class: "pi pi-lock",
  style: {"font-size":"1.5rem"}
}
const _hoisted_10 = {
  style: {"margin":"10px"},
  class: "flex ml-0 mr-0"
}
const _hoisted_11 = { class: "w-100pc p-input-icon-left p-input-icon-right" }
const _hoisted_12 = {
  key: 0,
  class: "align-items-center",
  style: {"position":"relative"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { style: {"position":"relative"} }
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "compass-red" }
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "grid flex-nowrap" }
const _hoisted_21 = {
  key: 0,
  class: "col-fixed service-price"
}
const _hoisted_22 = { class: "grid flex-nowrap" }
const _hoisted_23 = {
  key: 0,
  class: "ml-1 mt-1",
  style: {"color":"red"}
}
const _hoisted_24 = {
  key: 0,
  style: {"margin-left":"50px","margin-top":"4px"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "col-fixed hidden md:block service-ref" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "col-fixed hidden md:block lg:col-1 service-type" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "col-2 hidden md:block" }
const _hoisted_31 = {
  key: 1,
  class: "flex"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "text-center col-fixed service-aniv" }
const _hoisted_36 = {
  key: 0,
  class: "grid flex-nowrap p-2"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = {
  key: 1,
  class: "col-fixed text-right service-price"
}
const _hoisted_43 = {
  key: 0,
  class: "grid flex-nowrap p-2"
}
const _hoisted_44 = { class: "mt-2 ml-2" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "col-fixed last-email-to-supplier-sent" }
const _hoisted_47 = {
  key: 0,
  class: "text-center"
}
const _hoisted_48 = {
  key: 1,
  class: "text-center"
}
const _hoisted_49 = { class: "col-fixed text-right service-active" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 0,
  class: "pi pi-circle-fill mt-2"
}
const _hoisted_52 = {
  key: 1,
  class: "pi pi-circle mt-2"
}
const _hoisted_53 = {
  key: 1,
  class: "pi pi-check ml-4"
}
const _hoisted_54 = {
  key: 2,
  class: "col text-right pl-0"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "grid"
}
const _hoisted_57 = { class: "col-11" }
const _hoisted_58 = {
  key: 0,
  class: "notes-block"
}
const _hoisted_59 = { class: "notes-block-label" }
const _hoisted_60 = { class: "notes-block-content" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "notes-block"
}
const _hoisted_63 = { class: "notes-block-label" }
const _hoisted_64 = { class: "notes-block-content" }
const _hoisted_65 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_CompanySummaryPanel = _resolveComponent("CompanySummaryPanel")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_DocumentGeneration = _resolveComponent("DocumentGeneration")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col" }, [
              _createElementVNode("h4", null, "Services")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                    key: 0,
                    style: {"width":"40px","height":"40px"},
                    strokeWidth: "3"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNotes=!_ctx.showNotes)),
                class: "mr-4"
              }, [
                (_ctx.showNotes)
                  ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_6, null, 512)), [
                      [
                        _directive_tooltip,
                        'Show / Hide notes',
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                (!_ctx.showNotes)
                  ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_7, null, 512)), [
                      [
                        _directive_tooltip,
                        'Show / Hide notes',
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.editMode=!_ctx.editMode;_ctx.editModeChanged()})
                  }, [
                    (_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                      : _createCommentVNode("", true),
                    (!_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.serviceListFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.serviceListFilter) = $event)),
                placeholder: "Service keyword filter.."
              }, null, 8, ["modelValue"]),
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
            ]),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!_ctx.showAddService)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onClick: _ctx.toggleNewService,
                        class: "ml-1 mr-1",
                        icon: "pi pi-plus"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAddService)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        onClick: _ctx.toggleNewService,
                        class: "ml-1 mr-1",
                        icon: "pi pi-minus"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAddService)
                    ? (_openBlock(), _createBlock(_component_Listbox, {
                        key: 2,
                        modelValue: _ctx.selectedNewService,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedNewService) = $event)),
                        options: _ctx.allServices,
                        filter: true,
                        filterFields: ['serviceName'],
                        filterPlaceholder: 'Find a service',
                        listStyle: "max-height:250px;width:300px;",
                        style: {"position":"absolute","right":"0px","top":"50px","z-index":"1"},
                        onChange: _ctx.addService
                      }, {
                        value: _withCtx((data) => [
                          (data.value.serviceName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(data.value.serviceName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        option: _withCtx((data) => [
                          _createElementVNode("span", null, _toDisplayString(data.option.serviceName), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "onChange"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.showSnoozeOptions)
                ? (_openBlock(), _createBlock(_component_Listbox, {
                    key: 0,
                    modelValue: _ctx.selectedSnoozeDays,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSnoozeDays) = $event)),
                    options: _ctx.snoozeOptions,
                    optionValue: "value",
                    optionLabel: "label",
                    listStyle: "max-height:250px;width:300px;",
                    style: {"position":"absolute","right":"0px","top":"50px","z-index":"991"},
                    onChange: _ctx.snoozeSupplierEmails
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("a", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.showSnoozeOptions = false;})
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "pi pi-times" }, null, -1)
                          ]))])
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Snooze options for:", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedPropertyServiceToSnooze.serviceName), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "onChange"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_DataView, {
              value: _ctx.filteredServices,
              datakey: "propertyServiceId",
              paginator: true,
              rows: 50,
              scrollable: true,
              stripedRows: "",
              class: "p-datatable-sm property-service-table",
              paginatorTemplate: _ctx.paginatorTemplate,
              rowsPerPageOptions: [10,20,50,100,200],
              responsiveLayout: "scroll",
              alwaysShowPaginator: false,
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-2" }, "Service", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-1 hidden md:block service-ref" }, "Ref", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-fixed hidden md:block service-type" }, "Service Type", -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-2 hidden md:block" }, "Supplier", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-center col-fixed service-aniv" }, "Anniversary   Previous", -1)),
                    (_ctx.$store.getters.isInternalUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Price / Interval"))
                      : _createCommentVNode("", true),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-fixed last-email-to-supplier-sent" }, "Last Email Sent", -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-fixed service-active" }, "Active", -1))
                  ])
                ])
              ]),
              list: _withCtx(({data}) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-12 property-service-item hover-row", [_ctx.getServiceClass(data)]])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.loadedTime < data.whenCreated)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_23, "[new]"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-2 service-name compass-red", [data.parentServiceId ? 'pl-4':'']])
                    }, [
                      _createTextVNode(_toDisplayString(data.serviceName) + " ", 1),
                      (_ctx.editMode && !_ctx.hasContentOrWhitespace(data.adminNotes) && !_ctx.hasContentOrWhitespace(data.exceptionNotes) && _ctx.showNotes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("i", {
                              class: "pi pi-comment",
                              onClick: ($event: any) => (_ctx.toggleNotes(data))
                            }, null, 8, _hoisted_25)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_26, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(data.ref), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: data.ref,
                            "onUpdate:modelValue": ($event: any) => ((data.ref) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (!_ctx.editMode && data.serviceType)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(data.serviceType.replace(' Service','')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_Dropdown, {
                            key: 1,
                            class: "flex",
                            modelValue: data.serviceType,
                            "onUpdate:modelValue": ($event: any) => ((data.serviceType) = $event),
                            options: _ctx.serviceTypes
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 0,
                            options: _ctx.supplierList,
                            searchable: true,
                            limit: 40,
                            filter: true,
                            class: "flex",
                            modelValue: data.supplierCompanyId,
                            "onUpdate:modelValue": ($event: any) => ((data.supplierCompanyId) = $event),
                            valueProp: "id",
                            label: "nameAndId",
                            "track-by": "nameAndId",
                            placeholder: "Select a Supplier",
                            onSelect: ($event: any) => (_ctx.updateSupplierName(data)),
                            onClear: ($event: any) => (_ctx.clearSupplierName(data))
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect", "onClear"]))
                        : _createCommentVNode("", true),
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (data.supplierName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(data.supplierName), 1))
                              : _createCommentVNode("", true),
                            _cache[23] || (_cache[23] = _createTextVNode("   ", -1)),
                            (data.supplierCompanyId && _ctx.$store.getters.isInternalUser || _ctx.$store.getters.isCustomer)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.toggleSupplierDetails(data))
                                }, [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
                                ]))], 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (_ctx.$store.getters.isInternalUser && data.supplierCompanyId && _ctx.showEnvelopeForSubServiceLine(data))
                              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "ml-2",
                                  onClick: ($event: any) => (_ctx.toggleSupplierEnvelope(data))
                                }, [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
                                ]))], 8, _hoisted_34)), [
                                  [
                                    _directive_tooltip,
                                    'Automated Email',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createVNode(_component_Calendar, {
                              modelValue: data.whenNextServiceAnniversary,
                              "onUpdate:modelValue": ($event: any) => ((data.whenNextServiceAnniversary) = $event),
                              dateFormat: "d M yy"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _withDirectives(_createVNode(_component_Button, {
                              class: "flex",
                              icon: "pi pi-plus",
                              onClick: ($event: any) => (data.whenNextServiceAnniversary = _ctx.addYear(data.whenNextServiceAnniversary))
                            }, null, 8, ["onClick"]), [
                              [
                                _directive_tooltip,
                                'Add 1 year',
                                void 0,
                                { top: true }
                              ]
                            ]),
                            _cache[24] || (_cache[24] = _createTextVNode("   ", -1)),
                            _createVNode(_component_Calendar, {
                              modelValue: data.whenLastComplianceReceived,
                              "onUpdate:modelValue": ($event: any) => ((data.whenLastComplianceReceived) = $event),
                              dateFormat: "d M yy"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _withDirectives(_createVNode(_component_Button, {
                              icon: "pi pi-plus",
                              onClick: ($event: any) => (data.whenLastComplianceReceived = _ctx.addYear(data.whenLastComplianceReceived))
                            }, null, 8, ["onClick"]), [
                              [
                                _directive_tooltip,
                                'Add 1 year',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                            (data.whenNextServiceAnniversary)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.formattedDate(data.whenNextServiceAnniversary)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_39, "Not assigned")),
                            _cache[25] || (_cache[25] = _createTextVNode("   ", -1)),
                            (data.whenLastComplianceReceived)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.formattedDate(data.whenLastComplianceReceived)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_41, "Not assigned"))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.$store.getters.isInternalUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createVNode(_component_InputNumber, {
                                  modelValue: data.price,
                                  "onUpdate:modelValue": ($event: any) => ((data.price) = $event),
                                  class: "price-input",
                                  mode: "decimal",
                                  minFractionDigits: 2
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_44, [
                                  _createTextVNode(_toDisplayString(data.intervalMonths), 1)
                                ])), [
                                  [
                                    _directive_tooltip,
                                    'invoicing interval',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("span", null, "$" + _toDisplayString(data.price) + " /", 1),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(data.intervalMonths), 1)
                                ])), [
                                  [
                                    _directive_tooltip,
                                    'invoicing interval',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_46, [
                      (data.whenLastSupplierEmailTriggered > data.whenLastSupplierEmailSent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("Queued", -1)
                            ]))])), [
                              [
                                _directive_tooltip,
                                _ctx.lastTriggeredTooltip(data.whenLastSupplierEmailTriggered),
                                void 0,
                                { top: true }
                              ]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [
                              _createTextVNode(_toDisplayString(_ctx.formattedDate(data.whenLastSupplierEmailSent)), 1)
                            ])), [
                              [
                                _directive_tooltip,
                                _ctx.lastTriggeredTooltip(data.whenLastSupplierEmailTriggered),
                                void 0,
                                { top: true }
                              ]
                            ]),
                            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                            (!_ctx.editMode && data.whenSupplierEmailsSnoozedUntil > new Date())
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" (Snoozed) ")
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (data.active =!data.active)
                          }, [
                            (data.active)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_51))
                              : (_openBlock(), _createElementBlock("i", _hoisted_52))
                          ], 8, _hoisted_50)), [
                            [
                              _directive_tooltip,
                              'Toggle active',
                              void 0,
                              { top: true }
                            ]
                          ])
                        : (data.active)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_53))
                          : _createCommentVNode("", true)
                    ]),
                    (_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            onClick: ($event: any) => {data.whenDeleted = new Date();}
                          }, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "pi pi-times mt-2" }, null, -1)
                          ]))], 8, _hoisted_55)), [
                            [
                              _directive_tooltip,
                              'Remove service',
                              void 0,
                              { top: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ((_ctx.editMode || _ctx.hasContent(data.adminNotes) || _ctx.hasContent(data.exceptionNotes)) && _ctx.showNotes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", {
                          class: "col-1",
                          style: {"text-align":"right"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_57, [
                          (_ctx.$store.getters.isInternalUser)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.hasContent(data.adminNotes) || (_ctx.editMode && (_ctx.hasContentOrWhitespace(data.adminNotes) || _ctx.hasContentOrWhitespace(data.exceptionNotes))))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_59, [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("Internal Notes", -1)
                                      ]))])), [
                                        [
                                          _directive_tooltip,
                                          'Internal admin notes are available to Compass admin staff, but not shared with customer logins.',
                                          void 0,
                                          { top: true }
                                        ]
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        (!_ctx.editMode)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(data.adminNotes), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.editMode)
                                          ? (_openBlock(), _createBlock(_component_TextArea, {
                                              key: 1,
                                              modelValue: data.adminNotes,
                                              "onUpdate:modelValue": ($event: any) => ((data.adminNotes) = $event),
                                              rows: "2",
                                              autoResize: true
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.hasContent(data.exceptionNotes) || (_ctx.editMode && (_ctx.hasContentOrWhitespace(data.adminNotes) || _ctx.hasContentOrWhitespace(data.exceptionNotes))))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_63, [...(_cache[30] || (_cache[30] = [
                                  _createTextVNode("Exception Notes", -1)
                                ]))])), [
                                  [
                                    _directive_tooltip,
                                    'Exception notes are visible to customer logins.',
                                    void 0,
                                    { top: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  (!_ctx.editMode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(data.exceptionNotes), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.editMode)
                                    ? (_openBlock(), _createBlock(_component_TextArea, {
                                        key: 1,
                                        modelValue: data.exceptionNotes,
                                        "onUpdate:modelValue": ($event: any) => ((data.exceptionNotes) = $event),
                                        rows: "2",
                                        autoResize: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            }, 8, ["value", "paginatorTemplate"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showSupplierDetails,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSupplierDetails) = $event)),
      baseZIndex: 1000,
      position: "right",
      class: "p-sidebar-md"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompanySummaryPanel, { companyId: _ctx.supplierSummaryId }, null, 8, ["companyId"]),
        (_ctx.$store.getters.isInternalUser)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.documentTypes.supplier, (doc) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-4 p-0 m-0",
                key: doc.label
              }, [
                (_ctx.showTemplateButtons(doc))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "template-button",
                      onClick: ($event: any) => (_ctx.toggleDocumentGenerationDialog(doc.templateName))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(doc.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.showDocumentGenerationComponent)
      ? (_openBlock(), _createBlock(_component_DocumentGeneration, {
          key: 0,
          selectedDocumentTemplate: _ctx.selectedDocumentTemplate,
          selectedEmailTemplate: _ctx.selectedEmailTemplate,
          propertyData: _ctx.propertyData,
          toggledService: _ctx.getServiceForToggledSupplier,
          initialActiveTab: _ctx.documentGenerationActiveTab,
          recipientCompanyId: _ctx.getServiceForToggledSupplier.supplierCompanyId,
          onUpdateShowDocumentGenerationComponent: _cache[7] || (_cache[7] = ($event: any) => {_ctx.showDocumentGenerationComponent = $event;}),
          onReloadData: _ctx.reloadData
        }, null, 8, ["selectedDocumentTemplate", "selectedEmailTemplate", "propertyData", "toggledService", "initialActiveTab", "recipientCompanyId", "onReloadData"]))
      : _createCommentVNode("", true)
  ], 64))
}